var tld = require("../extlib/tld.js-master");
var punycode = require("../extlib/punycode.mod");

function Url () {
}

Url.trimHttpPrefix = function (url) {
    if (url == null) return "";
    return url.replace(/^https?:\/\//i, "");
};

Url.getProtocol = function (url) {
    if (url == null) return "";
    return url.replace(/^([a-z0-9+._]+:).*/i, "$1");
};

Url.getDomain = function (url) {
    if (url == null) return "";
    return (Url.trimHttpPrefix(url)).split(/\/+/g)[0].split(/:/g)[0];
};

Url.normalizeUrl = function (url) {
    if (url == null) return "";
    return url.replace(/index\.[^\/]*$/i, "").replace(/\/$/, "");
};

Url.normalizeDomain = function (domain) {
    if (domain == null) return "";
    return domain.replace(/^(www\.)+/i, "");
};

Url.normalizeLocation = function (location) {
    if (location == null) return "";
    return location.replace(/\/$/, "");
};

Url.isIdenticalURL = function (urlA, urlB) {
    if (urlA == null || urlB == null) return false;
    return (Url.normalizeUrl(Url.trimHttpPrefix(urlA.toLowerCase())) === Url.normalizeUrl(Url.trimHttpPrefix(urlB.toLowerCase())));
};

Url.hasIdenticalDomain = function (urlA, urlB) {
    if (urlA == null || urlB == null) return false;
    return (Url.normalizeDomain(Url.getDomain(urlA.toLowerCase())) === Url.normalizeDomain(Url.getDomain(urlB.toLowerCase())));
};

//returns an object
Url.splitByQueryString = function (url) {
    var parts = {location: "", queryString: ""};

    if (url == null) return parts;

    var pos = url.indexOf("?");

    if (pos === -1) {
        parts.location = url.substring(0);
        parts.queryString = "";
    } else {
        parts.location = url.substring(0, pos);
        parts.queryString = url.substring(pos);
    }
    return parts;
};

Url.removeTrailingSlashes = function (url) {
    if (url == null) return "";
    return url.replace(/\/+$/, "");
};

Url.removeBeginSlashes = function (url) {
    if (url == null) return "";
    return url.replace(/^\/+/, "");
};

Url.concat = function (url1, url2) {
    url1 = (url1 == null) ? "" : url1;
    url2 = (url2 == null) ? "" : url2;

    return Url.removeTrailingSlashes(url1) + "/" + Url.removeBeginSlashes(url2);
};

// www.example.com.tw -> com.tw
// nonsence -> null
Url.getSuffix = function (domain) {

    return tld.getPublicSuffix(domain);
};

// www.example.com.tw -> example.com.tw
// nonsence -> ""
Url.getOrgDomain = function (domain) {

    if (domain == null) return "";

    if (Url.hasIP(domain) === true) {

        return domain;

    }else{

        var orgDomain = tld.getDomain(domain);

        if(orgDomain == null){

            return "";
        }

        return orgDomain;
    }
};

// www.example.com.tw -> example
// nonsence -> ""
Url.getOrgName = function (domain, toUnicode) {

    if (domain == null) return "";

    if(Url.hasIP(domain) === true){

        return domain;

    }else{

        var orgDomain = tld.getDomain(domain);
        // var orgDomain = Url.getOrgDomain(domain);

        if(orgDomain == null){

            return "";

        }else{

            var name = orgDomain.split(".")[0];
            return (toUnicode === true) ? (Url.punycodeToUnicode(name)) : (name);
        }
    }
};

// xn--l8j2c3dva4f -> あまちゃん
// xn--l8j2c3dva4f.com -> あまちゃん.com
// ascii.com -> ascii.com
Url.punycodeToUnicode = function (domain) {

    if (domain == null) return "";

    return punycode.toUnicode(domain);
};


Url.hasIP = function (domain) {
    var re = /\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/; 

    return re.test(domain);
};


module.exports = Url;





